import { EnvironmentFeatureFlagStateDto } from '@flagsync/skyline';
import { FlaskConical } from 'lucide-react';
import { useState } from 'react';

import { AudienceTargetingCellBase } from '@/pages/authenticated/dashboard/flags/components/flag-table/cells/audience-targeting-cell';
import { CurrentlyServingCellBase } from '@/pages/authenticated/dashboard/flags/components/flag-table/cells/currently-serving-cell';
import { CopyToClipboard } from '@/components/copy-to-clipboard';
import { Switch } from '@/components/ui/switch';

export function FeatureCarouselCard({
  flag,
}: {
  flag: EnvironmentFeatureFlagStateDto;
}) {
  const [checked, setChecked] = useState(flag.isEnabled);

  flag.isEnabled = checked;

  return (
    <>
      <div className="flex items-center gap-1">
        <Switch
          id="toggle-flag"
          checked={checked}
          onCheckedChange={setChecked}
        />
        {flag.hasActiveExperiment && (
          <FlaskConical className="w-4 h-4 text-destructive animate-pulse" />
        )}
      </div>

      <div className="flex flex-col space-y-2 place-self-center items-start">
        <div className="flex space-x-2 items-center">
          <div className="font-semibold tracking-tighter text-base @lg:text-lg break-words subpixel-antialiased">
            {flag.featureFlag.name}
          </div>
        </div>
        <div className="space-x-1 items-center w-fit cursor-pointer hidden @md:flex">
          <CopyToClipboard
            value={flag.featureFlag.key}
            className="max-w-[160px] md:max-w-[220px] border border-halfmast-600 bg-transparent"
            textClassName="text-xs"
            iconClassName="w-4 h-4"
          />
        </div>
      </div>

      <div className="place-self-center">
        <CurrentlyServingCellBase flag={flag} className="text-xs" />
      </div>
      <div className="place-self-center hidden @lg:block">
        <AudienceTargetingCellBase flag={flag} containerClassName="gap-1" />
      </div>
    </>
  );
}
